import { render, staticRenderFns } from "./DashboardKidIcon.vue?vue&type=template&id=14238a44&"
import script from "./DashboardKidIcon.vue?vue&type=script&lang=js&"
export * from "./DashboardKidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports